// Central SEO config — change PROD_ORIGIN before real production deploy.
export const PROD_ORIGIN = 'https://www.foundergrowthcollective.co.uk';
export const SITE_NAME = 'Founder Growth Collective';
export const DEFAULT_OG_IMAGE = 'https://static.wixstatic.com/media/11062b_8391516c2f8e4551a8a86e84bac21931~mv2.jpg';
export const HANNAH_IMAGE = 'https://customer-assets-m6fa6gv7.emergentagent.net/job_fgc-premium-redesign/artifacts/xoczujl4_Untitled%20design%20%2835%29.png';
export const LOGO_URL = 'https://customer-assets-m6fa6gv7.emergentagent.net/job_fgc-premium-redesign/artifacts/kot2l99i_Change%20Text%20Color%20FOUNDER%20GROWTH%20%281%29.png';

// Determine current origin. In prod set PROD_ORIGIN; canonical URLs always use PROD_ORIGIN.
export function canonicalUrl(path = '/') {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${PROD_ORIGIN}${p === '/' ? '/' : p}`;
}

export function breadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      item: canonicalUrl(it.path),
    })),
  };
}

export function faqSchema(faqs) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };
}

export function serviceSchema({ name, description, path }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name,
    description,
    provider: { '@id': `${PROD_ORIGIN}/#organization` },
    serviceType: name,
    areaServed: ['United Kingdom', 'Europe'],
    url: canonicalUrl(path),
  };
}

export function webPageSchema({ path, name, description }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${canonicalUrl(path)}#webpage`,
    url: canonicalUrl(path),
    name,
    description,
    isPartOf: { '@id': `${PROD_ORIGIN}/#website` },
    inLanguage: 'en-GB',
  };
}
